import React from "react";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";

const HtmlTooltip = styled(({ className, offset, ...props }) => (
  <Tooltip
    {...props}
    classes={{ popper: className }}
    enterTouchDelay={0}
    PopperProps={{
      popperOptions: {
        modifiers: [
          {
            name: "offset",
            options: { offset: offset || [0, -18] },
          },
        ],
      },
    }}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#FFFFFF",
    borderRadius: "5px",
    color: "#4A4D52",
    maxWidth: 250,
    fontSize: "12px",
    border: "1px solid #dadde9",
    padding: "10px",
    boxShadow: "4px 4px 16px 0 #DEE1F7",
    marginBottom: "-10px important",
  },
}));

const CustomTooltip = ({ children, offset, ...props }) => {
  return (
    <HtmlTooltip offset={offset} placement="top" {...props}>
      {children}
    </HtmlTooltip>
  );
};

export default CustomTooltip;
